import { useState } from "react"
import { Container, Text, Title } from "components/Form"
import { ConfigContainer } from "components"
import { useDispatch } from "react-redux"
import { customerAdministration, members } from "state_management"
import useT from "utils/hooks/useT"

export default function AdminInputConfig({ admin, customerId, onClose }) {
  const { t } = useT("common")
  const dispatch = useDispatch()
  // A Member has no `name` field — this used to read admin.name, so the form always opened empty
  // and sent a `name` the API silently discarded. `initials` is the Member's actual identifier.
  const [activeAdminInitials, setActiveAdminInitials] = useState(admin ? admin.initials : "")
  const [activeAdminEmail, setActiveAdminEmail] = useState(admin ? admin.email : "")
  const isEdit = Boolean(admin)

  return (
    <ConfigContainer
      title={admin ? t("editAdmin") : t("addAdminTitle")}
      cancelHandler={onClose}
      submitHandler={() => {
        if (isEdit) {
          // `initials` goes over the generic admin PATCH. The email is the SPEC-057 L2
          // customer-admin emergency path (a user who lost their mailbox): a direct write via
          // the credentials endpoint, domain-validated server-side. Passwords are NEVER set by
          // anyone else — that is what the reset/welcome mails are for.
          const emailChanged = activeAdminEmail !== admin.email
          const emailPromise = emailChanged
            ? dispatch(members.updateCredentials(admin.id, { email: activeAdminEmail }))
            : Promise.resolve()
          return emailPromise
            .then(() => dispatch(customerAdministration.editAdmin(admin.id, { initials: activeAdminInitials })))
            .then(onClose)
        }

        // SPEC-057 L2: admins are created WITHOUT a password — the welcome mail carries a code
        // and they pick their own on the login screen ("forgot password" flow).
        return dispatch(
          customerAdministration.addAdmin(customerId, {
            initials: activeAdminInitials,
            email: activeAdminEmail,
          })
        ).then(onClose)
      }}
    >
      <Container>
        <Title>{t("initials")}</Title>
        <Text
          required
          textTransform="uppercase"
          value={activeAdminInitials}
          onChange={(e) => setActiveAdminInitials(e)}
        />
      </Container>
      <Container>
        <Title>{t("email")}</Title>
        <Text
          required
          type="email"
          value={activeAdminEmail}
          onChange={(e) => setActiveAdminEmail(e)}
        />
      </Container>
      {isEdit && <p className="AdminInputConfig-email-hint">{t("adminEmailChangeHint")}</p>}
      {!isEdit && <p className="AdminInputConfig-email-hint">{t("welcomeMailOnCreateInfo")}</p>}
    </ConfigContainer>
  )
}
